export const engagementAppGroupIdGptMessageQa = "/engagement/:app_group_id/gpt_message_qa";
